<template>
  <div class="contact">
    <div class="container">
      <div class="contact__wrapper">
        <div class="contact__info">
          <h1 class="contact__title">{{ t('contact.title') }}</h1>
          <a :href="'mailto:' + companyInfo.emailFrom">{{ companyInfo.emailFrom }}</a>
          <a :href="'tel:' + companyInfo.companyPhoneNumber">{{ companyInfo.companyPhoneNumber }}</a>
          <p>{{ companyInfo.companyAddress }}</p>
        </div>
        <contact-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {useCompanyStore} from "@/stores/company.js";
import {computed} from "vue";
import ContactForm from "@/components/forms/contact-form.vue";

const {t} = useI18n()
const companyStore = useCompanyStore()

const companyInfo = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})
</script>

<style lang="scss" scoped>
.contact {
  padding-block: 50px;

  &__wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 50px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & a {
      position: relative;
      width: fit-content;
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
      background: linear-gradient(90deg, #FF6162 0%, #EB5393 93.44%, #F4915D 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        width: 0;
        transition: all .3s ease;
        background-color: #FF6162;
      }

      @include hover {
        &::after {
          width: 100%;
        }
      }
    }

    & p {
      color: #2F2F2F;
      font-size: 14px;
      font-weight: 300;
      line-height: 28px; /* 140% */
    }
  }

  &__title {
    color: #2F2F2F;
    font-size: 72px;
    font-weight: 600;
    line-height: 76px;
  }
}

@media (max-width: 1000px) {
  .contact {
    &__wrapper {
      flex-direction: column;
      align-items: center;
    }

    &__info {
      align-items: center;
      gap: 10px;

      & p {
        text-align: center;
      }
    }

    &__title {
      text-align: center;
    }
  }
}

@media (max-width: 600px) {
  .contact {
    &__title {
      font-size: 48px;
      line-height: 52px;
    }

    &__info {
      & p {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
</style>